import { USER_SIGNED_OUT } from 'redux-oidc';
import {
  TOOLTIP_OPEN,
  TOOLTIP_CLOSE,
  SPINNER_OPEN,
  SPINNER_CLOSE,
  USER_LOAD,
  PROFILE_INFO_SAVE,
  ERROR_PAGE_SET_ERROR,
  LAYOUT_SET_ERROR,
  USER_UPDATE,
  SET_BAD_REQUEST_ERROR,
  CLEAR_BAD_REQUEST_ERROR,
  SET_GLOBAL_COMPONENTS,
  CLEAR_GLOBAL_COMPONENTS,
} from '../actions/types';

export const initialState = {
  user: null,
  globalComponents: {},
  autoLoaded: false,
  layoutError: null,
  lastError: null,
  badRequestError: {},
  tooltipId: undefined,
  spinner: {
    instances: 0,
    isSpinning: false,
  },
};

export const app = (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_INFO_SAVE._SUCCESS: {
      const { user } = action.payload;
      state.user = user;
      return state;
    }
    case USER_UPDATE:
    case USER_LOAD._ERROR:
    case USER_LOAD._SUCCESS: {
      const { user } = action.payload;
      state.autoLoaded = true;
      state.user = user || null;
      return state;
    }
    case LAYOUT_SET_ERROR: {
      const { error } = action.payload;
      state.layoutError = error;
      return state;
    }
    case ERROR_PAGE_SET_ERROR: {
      const { error } = action.payload;
      state.lastError = error;
      return state;
    }
    case SET_BAD_REQUEST_ERROR: {
      const { error, request } = action.payload;
      state.badRequestError[request] = error;
      return state;
    }
    case CLEAR_BAD_REQUEST_ERROR: {
      const { request } = action.payload;
      state.badRequestError[request] = null;
      return state;
    }
    case SET_GLOBAL_COMPONENTS: {
      const { name, type, props } = action.payload;
      state.globalComponents[name] = { type, props };
      return state;
    }
    case CLEAR_GLOBAL_COMPONENTS: {
      const { name } = action.payload;
      state.globalComponents[name] = null;
      return state;
    }
    case SPINNER_OPEN: {
      const i = state.spinner.instances > 0 ? state.spinner.instances + 1 : 1;
      state.spinner.instances = i;
      state.spinner.isSpinning = i > 0;
      return state;
    }
    case SPINNER_CLOSE: {
      const i = state.spinner.instances >= 1 ? state.spinner.instances - 1 : 0;
      state.spinner.instances = i;
      state.spinner.isSpinning = i > 0;
      return state;
    }
    case USER_SIGNED_OUT: {
      return { ...initialState };
    }
    case TOOLTIP_OPEN: {
      const { id } = action.payload;
      state.tooltipId = id;
      return state;
    }
    case TOOLTIP_CLOSE: {
      state.tooltipId = undefined;
      return state;
    }
    default:
      return state;
  }
};
